import { render, staticRenderFns } from "./issueDetail.vue?vue&type=template&id=8c135b58&scoped=true&"
import script from "./issueDetail.vue?vue&type=script&lang=ts&"
export * from "./issueDetail.vue?vue&type=script&lang=ts&"
import style0 from "./issueDetail.vue?vue&type=style&index=0&id=8c135b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c135b58",
  null
  
)

export default component.exports